/**
 * PSP/CRE Tool v3.0 — i18n Configuration
 *
 * V4-005: react-i18next infrastructure.
 * Supported languages: en (English, default), ro (Romanian).
 * Language preference persists to localStorage key 'psp_ui_language'.
 *
 * Deferred: Tab1-4, Tab6 string extraction (follow-on sessions).
 * This session: Tab5 + Tab7 fully extracted.
 *
 * Author: Dr. Tatar Radu MD
 * Date: April 9, 2026
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en/translation.json';
import ro from '../locales/ro/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ro: { translation: ro },
    },
    lng: localStorage.getItem('psp_ui_language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes output
    },
  });

export default i18n;
